/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ieri",
        "-2": "alaltăieri",
        "0": "azi",
        "1": "mâine",
        "2": "poimâine",
        "future": {
          "few": "peste {0} zile",
          "one": "peste {0} zi",
          "other": "peste {0} de zile"
        },
        "past": {
          "few": "acum {0} zile",
          "one": "acum {0} zi",
          "other": "acum {0} de zile"
        }
      },
      "day-narrow": {
        "-1": "ieri",
        "-2": "alaltăieri",
        "0": "azi",
        "1": "mâine",
        "2": "poimâine",
        "future": {
          "few": "+{0} zile",
          "one": "+{0} zi",
          "other": "+{0} zile"
        },
        "past": {
          "few": "-{0} zile",
          "one": "-{0} zi",
          "other": "-{0} zile"
        }
      },
      "day-short": {
        "-1": "ieri",
        "-2": "alaltăieri",
        "0": "azi",
        "1": "mâine",
        "2": "poimâine",
        "future": {
          "few": "peste {0} zile",
          "one": "peste {0} zi",
          "other": "peste {0} de zile"
        },
        "past": {
          "few": "acum {0} zile",
          "one": "acum {0} zi",
          "other": "acum {0} de zile"
        }
      },
      "hour": {
        "0": "ora aceasta",
        "future": {
          "few": "peste {0} ore",
          "one": "peste {0} oră",
          "other": "peste {0} de ore"
        },
        "past": {
          "few": "acum {0} ore",
          "one": "acum {0} oră",
          "other": "acum {0} de ore"
        }
      },
      "hour-narrow": {
        "0": "ora aceasta",
        "future": {
          "few": "+{0} h",
          "one": "+{0} h",
          "other": "+{0} h"
        },
        "past": {
          "few": "-{0} h",
          "one": "-{0} h",
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "ora aceasta",
        "future": {
          "few": "peste {0} h",
          "one": "peste {0} h",
          "other": "peste {0} h"
        },
        "past": {
          "few": "acum {0} h",
          "one": "acum {0} h",
          "other": "acum {0} h"
        }
      },
      "minute": {
        "0": "minutul acesta",
        "future": {
          "few": "peste {0} minute",
          "one": "peste {0} minut",
          "other": "peste {0} de minute"
        },
        "past": {
          "few": "acum {0} minute",
          "one": "acum {0} minut",
          "other": "acum {0} de minute"
        }
      },
      "minute-narrow": {
        "0": "minutul acesta",
        "future": {
          "few": "+{0} m",
          "one": "+{0} m",
          "other": "+{0} m"
        },
        "past": {
          "few": "-{0} m",
          "one": "-{0} m",
          "other": "-{0} m"
        }
      },
      "minute-short": {
        "0": "minutul acesta",
        "future": {
          "few": "peste {0} min.",
          "one": "peste {0} min.",
          "other": "peste {0} min."
        },
        "past": {
          "few": "acum {0} min.",
          "one": "acum {0} min.",
          "other": "acum {0} min."
        }
      },
      "month": {
        "-1": "luna trecută",
        "0": "luna aceasta",
        "1": "luna viitoare",
        "future": {
          "few": "peste {0} luni",
          "one": "peste {0} lună",
          "other": "peste {0} de luni"
        },
        "past": {
          "few": "acum {0} luni",
          "one": "acum {0} lună",
          "other": "acum {0} de luni"
        }
      },
      "month-narrow": {
        "-1": "luna trecută",
        "0": "luna aceasta",
        "1": "luna viitoare",
        "future": {
          "few": "+{0} luni",
          "one": "+{0} lună",
          "other": "+{0} luni"
        },
        "past": {
          "few": "-{0} luni",
          "one": "-{0} lună",
          "other": "-{0} luni"
        }
      },
      "month-short": {
        "-1": "luna trecută",
        "0": "luna aceasta",
        "1": "luna viitoare",
        "future": {
          "few": "peste {0} luni",
          "one": "peste {0} lună",
          "other": "peste {0} luni"
        },
        "past": {
          "few": "acum {0} luni",
          "one": "acum {0} lună",
          "other": "acum {0} luni"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "trimestrul trecut",
        "0": "trimestrul acesta",
        "1": "trimestrul viitor",
        "future": {
          "few": "peste {0} trimestre",
          "one": "peste {0} trimestru",
          "other": "peste {0} de trimestre"
        },
        "past": {
          "few": "acum {0} trimestre",
          "one": "acum {0} trimestru",
          "other": "acum {0} de trimestre"
        }
      },
      "quarter-narrow": {
        "-1": "trim. trecut",
        "0": "trim. acesta",
        "1": "trim. viitor",
        "future": {
          "few": "+{0} trim.",
          "one": "+{0} trim.",
          "other": "+{0} trim."
        },
        "past": {
          "few": "-{0} trim.",
          "one": "-{0} trim.",
          "other": "-{0} trim."
        }
      },
      "quarter-short": {
        "-1": "trim. trecut",
        "0": "trim. acesta",
        "1": "trim. viitor",
        "future": {
          "few": "peste {0} trim.",
          "one": "peste {0} trim.",
          "other": "peste {0} trim."
        },
        "past": {
          "few": "acum {0} trim.",
          "one": "acum {0} trim.",
          "other": "acum {0} trim."
        }
      },
      "second": {
        "0": "acum",
        "future": {
          "few": "peste {0} secunde",
          "one": "peste {0} secundă",
          "other": "peste {0} de secunde"
        },
        "past": {
          "few": "acum {0} secunde",
          "one": "acum {0} secundă",
          "other": "acum {0} de secunde"
        }
      },
      "second-narrow": {
        "0": "acum",
        "future": {
          "few": "+{0} s",
          "one": "+{0} s",
          "other": "+{0} s"
        },
        "past": {
          "few": "-{0} s",
          "one": "-{0} s",
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "acum",
        "future": {
          "few": "peste {0} sec.",
          "one": "peste {0} sec.",
          "other": "peste {0} sec."
        },
        "past": {
          "few": "acum {0} sec.",
          "one": "acum {0} sec.",
          "other": "acum {0} sec."
        }
      },
      "week": {
        "-1": "săptămâna trecută",
        "0": "săptămâna aceasta",
        "1": "săptămâna viitoare",
        "future": {
          "few": "peste {0} săptămâni",
          "one": "peste {0} săptămână",
          "other": "peste {0} de săptămâni"
        },
        "past": {
          "few": "acum {0} săptămâni",
          "one": "acum {0} săptămână",
          "other": "acum {0} de săptămâni"
        }
      },
      "week-narrow": {
        "-1": "săpt. trecută",
        "0": "săpt. aceasta",
        "1": "săpt. viitoare",
        "future": {
          "few": "+{0} săpt.",
          "one": "+{0} săpt.",
          "other": "+{0} săpt."
        },
        "past": {
          "few": "-{0} săpt.",
          "one": "-{0} săpt.",
          "other": "-{0} săpt."
        }
      },
      "week-short": {
        "-1": "săpt. trecută",
        "0": "săpt. aceasta",
        "1": "săpt. viitoare",
        "future": {
          "few": "peste {0} săpt.",
          "one": "peste {0} săpt.",
          "other": "peste {0} săpt."
        },
        "past": {
          "few": "acum {0} săpt.",
          "one": "acum {0} săpt.",
          "other": "acum {0} săpt."
        }
      },
      "year": {
        "-1": "anul trecut",
        "0": "anul acesta",
        "1": "anul viitor",
        "future": {
          "few": "peste {0} ani",
          "one": "peste {0} an",
          "other": "peste {0} de ani"
        },
        "past": {
          "few": "acum {0} ani",
          "one": "acum {0} an",
          "other": "acum {0} de ani"
        }
      },
      "year-narrow": {
        "-1": "anul trecut",
        "0": "anul acesta",
        "1": "anul viitor",
        "future": {
          "few": "+{0} ani",
          "one": "+{0} an",
          "other": "+{0} ani"
        },
        "past": {
          "few": "-{0} ani",
          "one": "-{0} an",
          "other": "-{0} ani"
        }
      },
      "year-short": {
        "-1": "anul trecut",
        "0": "anul acesta",
        "1": "anul viitor",
        "future": {
          "few": "peste {0} ani",
          "one": "peste {0} an",
          "other": "peste {0} de ani"
        },
        "past": {
          "few": "acum {0} ani",
          "one": "acum {0} an",
          "other": "acum {0} de ani"
        }
      }
    },
    "locale": "ro"
  });
}